import Common from 'common';

class App extends Common {
    constructor() {
        super();
        this.datas = [];
    }

    toppage_bnr() {
        if ($('.top-slick .visual-bnr-item').length > 0) {
            $('.top-slick.visual-bnr-list').slick({
                centerMode: true,
                centerPadding: '0px',
                arrows: true,
                slidesPerRow: 3,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            slidesPerRow: 1,
                        },
                    },
                ],
            });
        }
    }

    footer_slick() {
        if ($('.partial-slick .visual-bnr-item').length > 0) {
            $('.partial-slick.visual-bnr-list').slick({
                centerMode: true,
                centerPadding: '0px',
                arrows: true,
                slidesPerRow: 3,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            slidesPerRow: 1,
                        },
                    },
                ],
            });
        }
    }

    scroll_addclass() {
        const $win = $(window);
        const $header = $('#header');
        $win.on('load', { passive: false }, function () {
            var value = $(this).scrollTop();
            if (value > 0) {
                $header.addClass('active');
            } else {
                $header.removeClass('active');
            }
        });

        document.addEventListener('scroll', function () {
            var value = $win.scrollTop();
            if (value > 0) {
                $header.addClass('active');
            } else {
                $header.removeClass('active');
            }
        }, { passive: true });

        $('.gsnav').on('click', function () {
            $('.menu-trigger', this).toggleClass('active');
            $('header .header-txt').toggleClass('active');
            return false;
        });
        $('.nav-link-btn').on('click', function () {
            $('.menu-trigger', this).removeClass('active');
            $('header .header-txt').removeClass('active');
        });
    }

    alert_link() {
        $('.alert').on('click', function () {
            location.href = 'https://www.kumenoyu.com/';
            return false;
        });
    }

    s_scroll() {
        $('a[href^="#"]').on('click', function () {
            var speed = 1000;
            var href = $(this).attr("href");
            var target = $(href == "#" || href == "" ? 'html' : href);
            var position = target.offset().top;
            $('body, html').animate({ scrollTop: position }, speed, 'swing');
            return false;
        });
    }

    faq_open() {
        $('.page-faq-item dd').hide();
        $('.page-faq').addClass('on');
        $('.page-faq-item dt').on('click', function () {
            $(this).toggleClass('open');
            $(this).next('dd').slideToggle();
        });
    }

    init() {
        var _self = this;
        _self.scroll_addclass();
        if (_self.get_browser()) {
            _self.toppage_slide();
        } else {
            _self.toppage_svg_slide();
        }
        _self.toppage_bnr();
        _self.footer_slick();
        _self.alert_link();
        _self.faq_open();
        _self.s_scroll();
    }
}
var app = new App();
$(function () {
    app.init();
});

$(window).on('load', function () {
    // app.footer_event();
});
